export default [
    {
        path: '/admin/drivers',
        name: 'indexDriversAdmin',
        meta: { title: 'indexDriversAdmin' },
        component: () => import('@/pages/admin/drivers'),
    },
    {
        path: "/admin/drivers/create",
        name: "createDriversAdmin",
        meta: { title: 'createDriversAdmin' },
        component: () => import('@/pages/admin/drivers/create'),
    },
    {
        path: "/admin/drivers/:id/edit",
        name: "editDriversAdmin",
        meta: { title: 'editDriversAdmin' },
        component: () => import('@/pages/admin/drivers/edit'),
    },
]